/**
 * Market Types
 * @type {{}}
 */
export const MARKET_TYPES = {
  1: 'W.M.3Way',
  2: 'W.M.2Way',
  3: 'Mobile.Outrights',
  8: 'Next Goal'
};
/**
 * Market type ids
 * @type {{THREE_WAY: number, TWO_WAY: number, OUTRIGHTS: number}}
 */
export const MARKET_TYPE_IDS = {
  'THREE_WAY': 3,
  'TWO_WAY': 2,
  'OUTRIGHTS': 1,
  'NEXT_GOAL': 8
};
/**
 * Market outcome names
 * @type {{}}
 */
export const MARKET_OUTCOME_NAMES = {
  1: ['W.M.1', 'W.M.X', 'W.M.2'],
  2: ['W.M.1',  'W.M.2'],
  8: [],
};
